import { useRouter } from "next/router";

import { ProductBySlugQuery_productBySlug_Product } from "@/Apollo/schema";
import { ProductDetailsReturnPolicyNote } from "@/components/ProductDetail/info/usp/ProductDetailsReturnPolicyNote";
import ProductUtils from "@/components/ProductDetail/utils/ProductUtils";
import { ProductDeliveryOptionItemList } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemList";
import { ProductDetailsUsDelivery } from "@/features/us-delivery/components/ProductDetailsUsDelivery";
import { UsDeliveryQuoteSoldNotice } from "@/features/us-delivery/components/UsDeliveryQuoteSoldNotice";
import { getUsDeliveryKind } from "@/features/us-delivery/us-delivery.utils";

type ProductDetailsDeliveryProps = {
  product: ProductBySlugQuery_productBySlug_Product;
};

export const ProductDetailsDelivery = ({
  product,
}: ProductDetailsDeliveryProps) => {
  const { locale } = useRouter();
  const productIsSold = ProductUtils.isSold(product);
  const isOwner = product.isOwner;

  if (isOwner) {
    return null;
  }

  // WHO-6509: nothing to deliver once sold; a US buyer who had a quote reads why.
  if (productIsSold) {
    return <UsDeliveryQuoteSoldNotice productId={product.id} />;
  }

  // WHO-6509: on /en-us a listing that ships to the US gets the US delivery block.
  const usDeliveryKind = getUsDeliveryKind(product, locale);

  return (
    <div className="flex flex-col space-y-3">
      {usDeliveryKind === "none" ? (
        <ProductDeliveryOptionItemList product={product} />
      ) : (
        <ProductDetailsUsDelivery product={product} kind={usDeliveryKind} />
      )}
      <ProductDetailsReturnPolicyNote merchantType={product.merchant?.type} />
    </div>
  );
};
